<script>
import { mapActions, mapState } from 'vuex';
import TwTitleBar from '../../components/TwTitleBar';
import TwDomainSelector from '../../components/TwDomainSelector';

export default {
  name: 'ItineraryEditWrapper',
  components: {
    TwTitleBar,
    TwDomainSelector,
  },
  data() {
    return {
      activeTab: '',
      tabs: [
        {
          id: 1,
          name: this.$t('itinerary.edit.general.title'),
          route: `/itinerary/edit/${this.$route.params.id}/general`,
        },
        {
          id: 2,
          name: this.$t('itinerary.edit.dayProgram.title'),
          route: `/itinerary/edit/${this.$route.params.id}/day-program`,
        },
        {
          id: 3,
          name: this.$t('itinerary.edit.include.title'),
          route: `/itinerary/edit/${this.$route.params.id}/include`,
        },
        {
          id: 4,
          name: this.$t('itinerary.edit.includeNot.title'),
          route: `/itinerary/edit/${this.$route.params.id}/include-not`,
        },
        {
          id: 5,
          name: this.$t('itinerary.edit.seo.title'),
          route: `/itinerary/edit/${this.$route.params.id}/seo`,
        },
      ],
    };
  },
  created() {
    const itineraryId = this.$route.params.id;
    this.getItinerary(itineraryId);
    this.getItineraryDomains(itineraryId);
  },
  methods: {
    ...mapActions({
      getItinerary: 'itinerary/getItinerary',
      clearState: 'itinerary/clearState',
      getItineraryDomains: 'itinerary/getItineraryDomains',
      addItineraryDomains: 'itinerary/addItineraryDomains',
      updateItineraryDomains: 'itinerary/updateItineraryDomains',
      selectItineraryDomain: 'itinerary/selectItineraryDomain',
      deselectItineraryDomain: 'itinerary/deselectItineraryDomain',
    }),
  },
  computed: {
    ...mapState({
      itinerary: state => state.itinerary.edit.item,
      itineraryDomains: state => state.itinerary.domains.items,
      selectedDomain: state => state.itinerary.domains.selected,
      loading: state => state.itinerary.domains.loading,
    }),
    breadcrumbs() {
      return [
        { text: this.$t('menu.itinerary.title'), to: '', disabled: true },
        { text: this.$t('breadcrumbs.ItineraryOverview'), to: { name: 'ItineraryOverview' } },
        {
          text: this.$t('breadcrumbs.ItineraryEdit'),
          to: { name: 'ItineraryEdit' },
          params: { id: this.$route.params.id },
        },
        {
          text: this.$t(`breadcrumbs.${this.$route.name}`),
          to: this.$route.path,
          params: { id: this.$route.params.id },
        },
      ];
    },
  },
  destroyed() {
    this.clearState();
  },
};
</script>

<template>
  <v-content>
    <tw-title-bar
      :title="$t('menu.itinerary.pages.edit.title')"
      :breadcrumbs="breadcrumbs"
    />
    <template v-if="itinerary">
      <tw-domain-selector
        :product-type-id="itinerary.productTypeId"
        :selected-domains="itineraryDomains"
        :selected-domain="selectedDomain"
        :loading="loading"
        @update="addItineraryDomains({ itineraryId: itinerary.id, domainIds: $event.domainIds })"
        @select="selectedDomain ? deselectItineraryDomain() : selectItineraryDomain($event)"
        @activate="updateItineraryDomains({ itineraryId: itinerary.id, itineraryDomains: [$event] })"
      />
      <v-flex class="px-4 py-4">
        <v-layout row>
          <v-flex xs12>
            <v-card>
              <v-tabs
                v-model="activeTab"
                active-class="blue-grey lighten-5"
              >
                <v-tab
                  v-for="tab in tabs"
                  :key="tab.id"
                  :to="tab.route"
                >
                  {{ tab.name }}
                </v-tab>
                <v-tabs-items>
                  <v-tab-item
                    v-for="tab in tabs"
                    :transition="false"
                    :reverse-transition="false"
                    :key="tab.id"
                    :value="tab.route"
                  />
                </v-tabs-items>
              </v-tabs>
              <router-view />
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </template>
  </v-content>
</template>



// WEBPACK FOOTER //
// src/pages/itinerary/ItineraryEditWrapper.vue